import Service 			from "./../../Libs/Service";

import { Version } 		from "./Version";
import { Elements }		from "./Elements";

let Emitter = new Service({

	Name: "Emitter",

	Libraries: [],

	Events: {

		//Переключение рабочей ноды: активные карты данных подменяются картами этой ноды
		"Cluster Working Node Changed": function(previousServerId, serverId) {

			this.useServer(serverId);

		},
		"Emitter Added": function(emitter) {

			if (emitter["version_id"] === Version.SelectedVersion?.id) {

				Broadcast.call("Send To iFrame", [{
					EmitterAdded: emitter
				}]);

			}

		},
		"Emitter Changed": function(emitter) {

			if (emitter["version_id"] === Version.SelectedVersion?.id) {

				Broadcast.call("Send To iFrame", [{
					EmitterChanged: emitter
				}]);

			}

		},
		"Emitter Removed": function(emitter) {

			if (emitter["version_id"] === Version.SelectedVersion?.id) {

				Broadcast.call("Send To iFrame", [{
					EmitterRemoved: emitter
				}]);

			}

		},
		"IFrame Data:StartEmitterPlaying": function(emitterId) {

			this.emitterPlaying[emitterId] = true;

			let emitter = Emitter.EmittersById[emitterId];
			if (emitter?.["version_id"] === Version.SelectedVersion.id && emitter?.["element_codename"] === Elements.SelectedElement?.codename) {

				Broadcast.call("Selected Element Emitter Playing Changed");

			}

		},
		"IFrame Data:StopEmitterPlaying": function(emitterId) {

			this.emitterPlaying[emitterId] = false;

			let emitter = Emitter.EmittersById[emitterId];
			if (emitter?.["version_id"] === Version.SelectedVersion.id && emitter?.["element_codename"] === Elements.SelectedElement?.codename) {

				Broadcast.call("Selected Element Emitter Playing Changed");

			}

		},
		"Refresh Iframe": function() {

			if (_.size(this.emitterPlaying) > 0) {

				this.emitterPlaying = {};

				Broadcast.call("Selected Element Emitter Playing Changed");

			}

		}
	},

	Actions: {

		//serverId - нода, с которой пришли данные
		"Emitters": function(emitters, data, size, serverId) {

			this.setEmitters(emitters, !data.EmittersCreativeId && !data.EmittersVersionId, serverId);

			// Первоначальная загрузка анимаций всех версий креатива
			if (data.EmittersCreativeId) Broadcast.call("Creative Emitters Loaded", [data.EmittersCreativeId]);
			if (data.EmittersVersionId) Broadcast.call("Version Emitters Loaded", [data.EmittersVersionId]);

		},

		"Emitter": function(emitter, data, size, serverId) {

			this.setEmitter(emitter, data.EmitterId, true, serverId);

		}

	},

	init() {

		//Карты данных по нодам кластера: у каждой ноды своя БД, и id версий и эмиттеров
		//на разных нодах совпадают, поэтому карты разделены по нодам (Client/Libs/Service.js, getServerMap)
		this.EmittersByIdByServer = {};
		this.EmittersByHierarchyByServer = {};

		this.emitterPlaying = {}; // Будем помечать тут статус проигрывания анимации который сообщается из iframe

		// Активные карты - карты рабочей ноды
		this.useServer(0);

	},

	// Активные карты данных рабочей ноды: при переключении ноды они подменяются ссылками на карты
	// этой ноды, поэтому код обращения к ним (EmittersById[id]) не меняется
	useServer(serverId) {

		serverId = serverId || 0;

		if (this.NodeServerId === serverId) return;

		this.NodeServerId = serverId;

		this.EmittersById = this.getServerMap(this.EmittersByIdByServer, serverId);
		this.EmittersByHierarchy = this.getServerMap(this.EmittersByHierarchyByServer, serverId);

	},

	setEmitters(emitters, isBroadcast = true, serverId) {

		_.each(emitters, emitter => {

			this.setEmitter(emitter, emitter.id, isBroadcast, serverId);

		});

	},

	// serverId - нода, с которой пришли данные: пишем в карты этой ноды
	setEmitter(emitter, emitterId, isBroadcast = true, serverId) {

		serverId = serverId || this.NodeServerId;

		let emittersById = this.getServerMap(this.EmittersByIdByServer, serverId),
			emittersByHierarchy = this.getServerMap(this.EmittersByHierarchyByServer, serverId);

		let oldEmitter = emittersById[emitterId];

		if (emitter) {

			emittersById[emitter.id] = emitter;

			if (!emittersByHierarchy[emitter["version_id"]]) emittersByHierarchy[emitter["version_id"]] = {};
			if (!emittersByHierarchy[emitter["version_id"]][emitter["screen_codename"]]) emittersByHierarchy[emitter["version_id"]][emitter["screen_codename"]] = {};
			if (!emittersByHierarchy[emitter["version_id"]][emitter["screen_codename"]][emitter["element_codename"]]) emittersByHierarchy[emitter["version_id"]][emitter["screen_codename"]][emitter["element_codename"]] = {};

			emittersByHierarchy[emitter["version_id"]][emitter["screen_codename"]][emitter["element_codename"]][emitter.codename] = emitter;

		} else if (oldEmitter) {

			delete emittersById[oldEmitter.id];
			delete emittersByHierarchy[oldEmitter["version_id"]][oldEmitter["screen_codename"]][oldEmitter["element_codename"]][oldEmitter.codename];

		}

		if (isBroadcast) {

			let eventPrefixes = ["Emitter"];
			// TODO: не хватает глобального доступа к имени выделенного экрана, чтобы однозначно определить меняется ли анимация выделенного элемента
			if (oldEmitter?.["version_id"] === Version.SelectedVersion?.id && oldEmitter?.["element_codename"] === Elements.SelectedElement?.codename) eventPrefixes.push("Selected Element Emitter"); // Это конечно не совсем точно - но примерно можно определить принадлежность к текущему элементу
			else if (emitter?.["version_id"] === Version.SelectedVersion?.id && emitter?.["element_codename"] === Elements.SelectedElement?.codename) eventPrefixes.push("Selected Element Emitter");

			// Определяем автоматически изменения в объектах и запускаем соответствующие события
			this.broadcastChanges(oldEmitter, emitter, eventPrefixes);

		}

	},

	getVersionEmitters(version) {

		return this.EmittersByHierarchy[version.id];

	},

	getEmitters(versionId, screenCodename, elementCodename) {

		return _.orderBy(_.values(this.EmittersByHierarchy[versionId]?.[screenCodename]?.[elementCodename]), 'id') || [];

	}

});

window.Emitter = Emitter;

export { Emitter }

